import React from 'react';
import { motion } from 'framer-motion';
import { Target, Landmark, Network } from 'lucide-react';
export function HumanOpportunity() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 bg-teal-pale border-y border-line/50" data-id="element-814">
      <div className="max-w-7xl mx-auto" data-id="element-815">
        <div className="max-w-3xl mb-16" data-id="element-816">
          <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-817">
            Human Opportunity and Development
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark mb-6" data-id="element-818">
            Every weakness should be paired with a pathway
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-819">
            NCJI is designed not only to identify limitations, but to translate
            them into development pathways, support structures, and opportunity
            expansion. The system should not stop at "not ready." It should show
            what readiness requires and how it can be built.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-820">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white p-8 rounded-lg border border-line shadow-sm" data-id="element-821">
            <div className="flex items-center gap-4 mb-4" data-id="element-822">
              <div className="text-teal" data-id="element-823">
                <Target size={24} strokeWidth={1.5} data-id="element-824" />
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark" data-id="element-825">
                Self-Directed Improvement
              </h3>
            </div>
            <p className="text-ink-muted" data-id="element-826">
              Tools, learning pathways, and structured action steps for
              individual growth.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white p-8 rounded-lg border border-line shadow-sm" data-id="element-827">
            <div className="flex items-center gap-4 mb-4" data-id="element-828">
              <div className="text-navy-light" data-id="element-829">
                <Landmark size={24} strokeWidth={1.5} data-id="element-830" />
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark" data-id="element-831">
                Institutional Support
              </h3>
            </div>
            <p className="text-ink-muted" data-id="element-832">
              Schools, employers, mentors, and development systems providing
              structured guidance.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white p-8 rounded-lg border border-line shadow-sm" data-id="element-833">
            <div className="flex items-center gap-4 mb-4" data-id="element-834">
              <div className="text-navy" data-id="element-835">
                <Network size={24} strokeWidth={1.5} data-id="element-836" />
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark" data-id="element-837">
                Community & Public Support
              </h3>
            </div>
            <p className="text-ink-muted" data-id="element-838">
              Programs, networks, and broader opportunity infrastructure scaling
              capability.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}